var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"van-content",staticStyle:{"padding":"10px 15px","background":"#fff!important"}},[_c('van-cell-group',{domProps:{"innerHTML":_vm._s(_vm.datas.content)}},[_vm._v(_vm._s(_vm.datas.content))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91be3be4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/do/zhinan.vue
// module id = null
// module chunks = 